// Overlay state shared by the shell: the system menu, the settings dialog, the level-up dialog and
// the outcome curtain.
// Screens open these through the store so the Esc key, the shell gear and the roster badge agree.
import { create } from 'zustand';
import type { StampTone } from './components/Banner';

/** A room's result shown by the outcome curtain (`OutcomeHost`). */
export interface Outcome { key: string; word: string; tone: StampTone; eyebrow?: string; sub?: string }

export interface OverlayStore {
  menu: boolean; settings: boolean; levelUp?: bigint; credits: boolean; outcome?: Outcome;
  /** docs/119: whose Path page is open (levels, training, talents). */
  heroPath?: bigint;
  openHeroPath(heroId: bigint): void; closeHeroPath(): void;
  openMenu(): void; closeMenu(): void; toggleMenu(): void;
  openSettings(): void; closeSettings(): void;
  openLevelUp(offerId: bigint): void; closeLevelUp(): void;
  openCredits(): void; closeCredits(): void;
  /** Shows the curtain once per `key` (an encounter id); later calls with the same key are ignored. */
  showOutcome(o: Outcome): void; clearOutcome(): void;
  /** True when any overlay is open (keyboard handlers stand down). */
  anyOpen(): boolean;
}

const shownOutcomes = new Set<string>();

export const useOverlay = create<OverlayStore>()((set, get) => ({
  menu: false, settings: false, credits: false,
  openMenu() { set({ menu: true }); }, closeMenu() { set({ menu: false }); }, toggleMenu() { set({ menu: !get().menu }); },
  openSettings() { set({ settings: true, menu: false }); }, closeSettings() { set({ settings: false }); },
  openLevelUp(levelUp) { set({ levelUp }); }, closeLevelUp() { set({ levelUp: undefined }); },
  openHeroPath(heroPath) { set({ heroPath }); }, closeHeroPath() { set({ heroPath: undefined }); },
  openCredits() { set({ credits: true }); }, closeCredits() { set({ credits: false }); },
  showOutcome(o) { if (shownOutcomes.has(o.key)) return; shownOutcomes.add(o.key); set({ outcome: o }); }, clearOutcome() { set({ outcome: undefined }); },
  anyOpen() { const s = get(); return s.menu || s.settings || s.levelUp !== undefined || s.heroPath !== undefined || s.credits; },
}));
